<div class='header'>
    <button class="buttonMenu" *ngIf="menuButton" (click)="toggleSidenav()"><mat-icon class="iconMenu">menu</mat-icon></button>
    <div [class]="menuButton ? 'logoContainer2' : 'logoContainer'">
        <div><img class="logo" [src]="logo" /></div>
        <div><img *ngIf="logo2" class="logo2" [src]="logo2" /></div>
        <div><img *ngIf="logo3" class="logo3" [src]="logo3" /></div>
    </div>
    <app-language-selector class="headerLanguageSelector"></app-language-selector>
</div>